import React, { useState, useEffect } from "react";
import { getStudios } from "../../api";
import { ReactComponent as ClockIcon } from "../../inlineSvgs/clock.svg";
import { ReactComponent as LogoIcon } from "../../inlineSvgs/logo.svg";
import { useDispatch, useSelector } from "react-redux";
import { changeSelectedStudio } from "../../store/slice/orderSlice";

const test = [
  {
    id: 1,
    title: "Mon Lis - Königsplatz",
    address: "Ohlstadter Straße 52, München, Sendling-Westpark",
    images: ["./img/studio.jpg"],
    schedule: {
      workingTimes: [
        {
          period: {
            from: "Date",
            to: "Date",
          },
          days: {
            0: {
              from: {
                hh: "09",
                mm: "00",
              },
              to: {
                hh: "20",
                mm: "00",
              },
            },
          },
        },
      ],
    },
    services: [
      {
        id: 2,
        title: "service title 1 salon 1",
        duration: 1,
        priceList: [
          {
            rank: "junior",
            price: 1,
          },
          {
            rank: "top",
            price: 3,
          },
        ],
        createdAt: "2023-10-17T11:17:17.810Z",
        categories: [
          {
            id: 1,
            title: "category  1 title",
          },
          {
            id: 2,
            title: "category  2 title",
          },
        ],
      },
      {
        id: 1,
        title: "service title 2 salon 1",
        duration: 1,
        priceList: [
          {
            rank: "junior",
            price: 1,
          },
          {
            rank: "top",
            price: 3,
          },
        ],
        createdAt: "2023-10-17T11:13:30.795Z",
        categories: [],
      },
    ],
  },
  {
    id: 2,
    title: "Mon Lis - Westpark",
    address: "Karlstraße 43, München, Maxvorstadt, 80333",
    images: ["./img/studio.jpg"],
    schedule: {
      workingTimes: [
        {
          period: {
            from: "Date",
            to: "Date",
          },
          days: {
            0: {
              from: {
                hh: "09",
                mm: "00",
              },
              to: {
                hh: "20",
                mm: "00",
              },
            },
          },
        },
      ],
    },
    services: [
      {
        id: 4,
        title: "service title 1 salon 2",
        duration: 1,
        priceList: [
          {
            rank: "junior",
            price: 1,
          },
          {
            rank: "top",
            price: 3,
          },
        ],
        createdAt: "2023-10-17T11:17:17.810Z",
        categories: [
          {
            id: 1,
            title: "category  1 title",
          },
          {
            id: 2,
            title: "category  2 title",
          },
        ],
      },
      {
        id: 5,
        title: "service title 2 salon 2",
        duration: 1,
        priceList: [
          {
            rank: "junior",
            price: 1,
          },
          {
            rank: "top",
            price: 3,
          },
        ],
        createdAt: "2023-10-17T11:13:30.795Z",
        categories: [],
      },
    ],
  },
];

const StudiosList = () => {
  const [studios, setStudios] = useState(null);

  useEffect(() => {
    getAllStudios();
  }, []);

  const getAllStudios = async () => {
    const studios = await getStudios();
    setStudios(studios?.data);
  };

  return (
    <div className="studios-list">
      <div className="title">Choose Your Ideal Beauty Studio</div>
      <div className="description">
        Discover the beauty studios in your area and select the one that suits your preferences.{" "}
      </div>
      <div className="studios">
        {!!studios?.length && studios.map((studio) => <Studio key={studio.id} {...studio} />)}
        <div className="coming-soon" style={{ backgroundImage: `url(./img/BG.jpg)` }}>
          <LogoIcon />
          <div className="text">
            <span>One more studio</span>
            <strong>Coming soon</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

const Studio = (studio) => {
  const { title, address, images, schedule } = studio;
  const bgImage = images.length ? images[0] : "./img/BG.jpg";
  const curentStudio = useSelector((state) => state.orderReducer.selectedStudio);
  const isActive = curentStudio && curentStudio.id === studio.id;
  const dispatch = useDispatch();

  const chooseStudio = () => {
    dispatch(changeSelectedStudio(studio));
  };

  const getWorkingTime = (schedule, day = 1) => {
    const workingTimes = schedule?.workingTimes;
    const dayTime = workingTimes && workingTimes[0]?.daysPeriods?.[day];

    if (dayTime) {
      const stringTime =
        dayTime.from.hours + ":" + dayTime.from.minutes + " - " + dayTime.to.hours + ":" + dayTime.to.minutes;
      return stringTime;
    }
  };

  const workingTime = getWorkingTime(schedule);

  return (
    <div
      className={isActive ? "studio curent" : "studio"}
      style={{ backgroundImage: `url(${bgImage})` }}
      onClick={chooseStudio}
    >
      <div className="studio__info">
        <p className="title">{title}</p>
        <p className="address">{address}</p>
        <p className="work-time">
          <ClockIcon />
          <strong>Work schedule:</strong>
          <span>{workingTime}</span>
        </p>
      </div>
    </div>
  );
};

export default StudiosList;
